import { type AxiosError } from 'axios'
import _get from 'lodash/get'

import { getErrorCode, HTTP_CODE_CONFLICT } from '@/lib/http/codes'
import { HttpError } from '@/lib/http/responses'

export const GOOGLE_REVIEW_NOT_FOUND_ERROR_CODE = 'google_review_not_found'

export function isGoogleReviewNotFoundError(error: AxiosError | HttpError | Error) {
  const status = getErrorCode(error)
  if (status !== HTTP_CODE_CONFLICT) {
    return false
  }

  return _get(error, 'response.data.code') === GOOGLE_REVIEW_NOT_FOUND_ERROR_CODE
}
